module.exports = __webpack_public_path__ + "img/logo3.5a026e2d.png";